import { api, unwrap } from './client';
import { eventFromApi, eventToApi } from './_transforms';

const PAGE_SIZE = 500;

export async function listEvents({ page = 0, size = PAGE_SIZE, sort = 'eventDate,desc', q, status } = {}) {
  const params = { page, size, sort };
  if (q) params.q = q;
  if (status) params.status = status.toUpperCase();
  const data = await unwrap(api.get('/api/events', { params }));
  return {
    content: (data.content || []).map(eventFromApi),
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    number: data.number,
  };
}

export async function listUpcomingEvents() {
  const data = await unwrap(api.get('/api/events/upcoming'));
  return (data || []).map(eventFromApi);
}

export async function getEvent(id) {
  const data = await unwrap(api.get(`/api/events/${id}`));
  return eventFromApi(data);
}

export async function createEvent(payload) {
  const data = await unwrap(api.post('/api/events', eventToApi(payload)));
  return eventFromApi(data);
}

export async function updateEvent(id, payload) {
  const data = await unwrap(api.put(`/api/events/${id}`, eventToApi(payload)));
  return eventFromApi(data);
}

export async function deleteEvent(id) {
  return unwrap(api.delete(`/api/events/${id}`));
}

/** Reopen booking after the day-before cut-off (open=true) or restore the cut-off (open=false). */
export async function setEventBooking(id, open) {
  const data = await unwrap(api.post(`/api/events/${id}/booking`, { open }));
  return eventFromApi(data);
}
